import { uniqueId } from "@/views/zhiji/js/common/util.js";
import { ParamError } from "@/views/zhiji/js/common/errors.js";
import i18n from "@/i18n";

export default {
    widgetName: "Time",
    serverType: "time",
    initContent() {
        return {
            uId: uniqueId(),
            updateState: "add",
            wtType: "Time",
            title: "",
            isNeed: false
        };
    },
    checkContent(content) {
        if (!content.title) {
            throw new ParamError(i18n.t("zhiji.form.time.error.title"));
        }
    },
    // 后台数据转前端数据
    server2Client(content) {
        return {
            uId: uniqueId(),
            num: content.num,
            wtType: "Time",
            updateState: "",
            title: content.title,
            isNeed: content.is_need
        };
    },
    // 前端数据转后台数据
    client2Server(content) {
        return {
            num: 0,
            title: content.title,
            type: "time",
            name: "time",
            is_need: content.isNeed,
            tip: "",
            value: "",
            readonly: "false"
        };
    }
};
